import { logWrapper } from '../utils';

function getterSetterDirectiveFactory(runtimeConstant) {
  function link(scope, el, attr) {
    // Define a dummy value in the scope variable
    scope[attr.outputModel] = scope.$parent.folder();

    scope.$watch('folder()', (newValue) => {
      const folder = scope[attr.outputModel];
      const nullCheck = (newValue === null && folder !== null) || (newValue !== null && folder === null);

      if (
        newValue !== undefined &&
        (nullCheck || (newValue !== null && newValue !== null && newValue.id !== folder.id))
      ) {
        scope[attr.outputModel] = scope.$parent.folder();
      }
    });

    scope.$watch(attr.outputModel, (newValue) => {
      const folder = scope.$parent.folder();
      const nullCheck = (newValue === null && folder !== null) || (newValue !== null && folder === null);

      if (
        newValue !== undefined &&
        (nullCheck || (newValue !== null && newValue !== null && newValue.id !== folder.id))
      ) {
        scope.$parent.folder(newValue);
      }
    });
  }

  function run() {
    return {
      restrict: 'A',
      link,
    };
  }

  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const getterSetterDirective = ['runtimeConstant', getterSetterDirectiveFactory];
